import { LineChart, Line, XAxis, YAxis, Tooltip, Legend } from 'recharts';
import { ChartContainer } from './ChartContainer';
import {
  useSpendingTrends,
  formatMonth,
  type SpendingTrendsOptions,
} from '../../hooks/useSpendingTrends';
import { formatMXN, getCategoryColor } from './constants';

interface SpendingTrendsChartProps extends SpendingTrendsOptions {
  height?: number;
}

const TOTAL_LINE_COLOR = '#1f2937';

export function SpendingTrendsChart({
  months = 6,
  categories,
  height = 350,
}: SpendingTrendsChartProps) {
  const { data, availableCategories } = useSpendingTrends({
    months,
    categories,
  });

  const categoriesToShow = categories
    ? availableCategories.filter((cat) => categories.includes(cat.id))
    : availableCategories;

  return (
    <ChartContainer height={height}>
      <LineChart data={data}>
        <XAxis dataKey="month" tickFormatter={formatMonth} />
        <YAxis tickFormatter={(v) => `$${(v / 1000).toFixed(0)}k`} />
        <Tooltip
          formatter={(value) =>
            value !== undefined ? formatMXN(Number(value)) : ''
          }
          labelFormatter={(label) =>
            typeof label === 'string' ? formatMonth(label) : String(label)
          }
        />
        <Legend />
        <Line
          type="monotone"
          dataKey="total"
          stroke={TOTAL_LINE_COLOR}
          strokeWidth={3}
          name="Total"
          dot={{ r: 4 }}
          activeDot={{ r: 6 }}
        />
        {categoriesToShow.map((category) => (
          <Line
            key={category.id}
            type="monotone"
            dataKey={category.id}
            stroke={getCategoryColor(category.id)}
            strokeWidth={1.5}
            name={category.name}
            dot={{ r: 3 }}
            activeDot={{ r: 5 }}
          />
        ))}
      </LineChart>
    </ChartContainer>
  );
}
